export enum UserOnboardStep {
  USER_DETAILS = 1,
  ORGANIZATION_DETAILS = 2
}
